import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";
import { Reveal } from "./anim";

export default function Services() {
  const { t } = useLang();
  const s = t.services;

  return (
    <section id="services" className="relative py-24 md:py-36 bg-cream" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20">
          {/* Left: heading + image */}
          <div className="lg:sticky lg:top-28 self-start">
            <Reveal>
              <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{s.overline}</p>
              <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.75rem] leading-[1.08] tracking-tight text-ink">
                {s.title}
              </h2>
              <p className="mt-8 font-light text-base leading-relaxed text-ink-soft max-w-md">{s.note}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="clip-frame mt-12 hidden lg:block">
                <img src={IMAGES.room} alt="" className="w-full h-[360px] object-cover" />
              </div>
            </Reveal>
          </div>

          {/* Right: list */}
          <div>
            {s.items.map((it, i) => (
              <motion.div
                key={it.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: (i % 2) * 0.06 }}
                className="group border-b border-ink/12 py-7 flex gap-6 items-start hover:pl-2 transition-[padding] duration-500"
                data-testid={`service-${it.n}`}
              >
                <span className="font-serif italic text-brand text-lg pt-1 w-8 shrink-0">{it.n}</span>
                <div>
                  <h3 className="font-serif text-2xl sm:text-3xl text-ink leading-tight group-hover:text-brand transition-colors duration-400">
                    {it.name}
                  </h3>
                  <p className="mt-2 font-light text-sm sm:text-base leading-relaxed text-ink-soft max-w-xl">
                    {it.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
